export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1518208682109-c56c3f9c3178?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxkYW5pc2glMjBob3Rkb2clMjBzYXVzYWdlJTIwc3RyZWV0JTIwZm9vZCUyMGNhdGVyaW5nfGVufDB8fHxyZWR8MTc4ODQ1NDkzM3ww&ixlib=rb-4.1.0&q=85",
    grill: "https://images.pexels.com/photos/25388989/pexels-photo-25388989.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    event1: "https://images.unsplash.com/photo-1683508700255-f9b09a11f687?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2NzF8MHwxfHNlYXJjaHwxfHxmb29kJTIwdHJ1Y2slMjBldmVudCUyMHBhcnR5fGVufDB8fHx8MTc4ODQ1NDk0Nnww&ixlib=rb-4.1.0&q=85",
    event2: "https://images.unsplash.com/photo-1612208176815-e132bcf971b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2NzF8MHwxfHNlYXJjaHwyfHxmb29kJTIwdHJ1Y2slMjBldmVudCUyMHBhcnR5fGVufDB8fHx8MTc4ODQ1NDk0Nnww&ixlib=rb-4.1.0&q=85",
};

// Hero carousel frame shape: "buet" (arched top), "firkantet" (square) or "uden" (no mask).
export const HERO_IMAGE_MASK = "buet";

export const SOCIAL = {
    facebook: "https://facebook.com/lejenpoelsevogn",
    instagram: "https://instagram.com/lejenpoelsevogn",
};

export const CONTACT = {
    owner: "Jørgen Birger",
    phone: "21 82 93 46",
    phoneHref: "+4521829346",
    email: "dlmpjb@gmail.com",
    cvr: "42314331",
};

const MENU1_ITEMS = [
    "Frankfurter i svøb",
    "Ristet pølse",
    "Ristet i svøb",
    "Ostepølser",
    "Chilipølser",
    "Ramsløgspølser",
    "Ristet hotdog",
    "Fransk hotdog",
];
const MENU2_ITEMS = [...MENU1_ITEMS, "Bøfsandwich", "Flæskestegssandwich"];
const MENU3_ITEMS = [...MENU2_ITEMS, "Cheeseburger", "Bacon cheeseburger"];
const MENU4_ITEMS = [...MENU3_ITEMS, "Oksefilet", "Kold kartoffelsalat", "Blandet salat", "Flutes"];

// Extra dishes added at each menu level (marked with "+" on the menu cards).
const MENU2_EXTRAS = ["Bøfsandwich", "Flæskestegssandwich"];
const MENU3_EXTRAS = ["Cheeseburger", "Bacon cheeseburger"];
const MENU4_EXTRAS = ["Oksefilet", "Kold kartoffelsalat", "Blandet salat", "Flutes"];

export const MENUS = [
    {
        id: "menu1",
        name: "Menu 1",
        tagline: "Pølserne i centrum",
        image: "https://images.unsplash.com/photo-1518208606308-e61fb98ded5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxkYW5pc2glMjBob3Rkb2clMjBzYXVzYWdlJTIwc3RyZWV0JTIwZm9vZCUyMGNhdGVyaW5nfGVufDB8fHxyZWR8MTc4ODQ1NDkzM3ww&ixlib=rb-4.1.0&q=85",
        items: [...MENU1_ITEMS],
        contents: MENU1_ITEMS,
        extras: [],
    },
    {
        id: "menu2",
        name: "Menu 2",
        tagline: "Pølser + sandwich-klassikerne",
        image: "https://images.unsplash.com/photo-1695089029207-9a25935fcbb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxkYW5pc2glMjBzYXVzYWdlJTIwY3Jpc3B5JTIwb25pb25zJTIwa2V0Y2h1cCUyMG11c3RhcmQlMjBwaWNrbGVzfGVufDB8fHx8MTc4ODQ1NDk0M3ww&ixlib=rb-4.1.0&q=85",
        items: MENU2_ITEMS,
        contents: MENU2_ITEMS,
        extras: MENU2_EXTRAS,
    },
    {
        id: "menu3",
        name: "Menu 3",
        tagline: "Burgerne kommer på menuen",
        image: "https://images.pexels.com/photos/25388989/pexels-photo-25388989.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: MENU3_ITEMS,
        contents: MENU3_ITEMS,
        extras: MENU3_EXTRAS,
    },
    {
        id: "menu4",
        name: "Menu 4",
        tagline: "Hele kortet på én gang",
        image: "https://images.unsplash.com/photo-1586764030506-55835e6bebba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxkYW5pc2glMjBzYXVzYWdlJTIwY3Jpc3B5JTIwb25pb25zJTIwa2V0Y2h1cCUyMG11c3RhcmQlMjBwaWNrbGVzfGVufDB8fHx8MTc4ODQ1NDk0M3ww&ixlib=rb-4.1.0&q=85",
        items: MENU4_ITEMS,
        contents: MENU4_ITEMS,
        extras: MENU4_EXTRAS,
    },
];

export const SERVING_TYPES = [
    { id: "almindelig", name: "Mad til arrangementet", description: "Pølsevognen kommer fra morgen og til aften – og alt derimellem. Hvad der passer til lige dit/jeres arrangement." },
    { id: "natmad", name: "Natmad – Rund festen af", description: "Send gæsterne godt hjem med pølser, hotdog og franske – måske en bøfsandwich mm." },
];

export const NATMAD_ADDITIONS = [
    { id: "boef", name: "Bøfsandwich" },
    { id: "flaeskesteg", name: "Flæskestegssandwich" },
];

export const TILVALG_SECTIONS = [
    {
        id: "tilpas-maden",
        title: "Tilpas maden",
        cols: "sm:grid-cols-2",
        groups: [
            {
                id: "glutenfri-groenne",
                title: "Glutenfri & grønne alternativer",
                items: [
                    "Glutenfri pølsebrød",
                    "Glutenfri burgerboller",
                    "Vegetarpølser",
                    "Vegetarburger",
                    "Veganerpølser",
                    "Veganerburger",
                ],
            },
            {
                id: "ekstra-fra-grillen",
                title: "Ekstra fra grillen",
                items: [
                    "Kyllingepølser",
                    "Røde pølser",
                    "Medister",
                    "Frikadellesandwich",
                    "Kyllingesandwich",
                ],
            },
        ],
    },
    {
        id: "drikkevarer-soedt",
        title: "Drikkevarer & sødt",
        cols: "md:grid-cols-3",
        groups: [
            {
                id: "kolde-drikke",
                title: "Kolde drikke",
                items: ["Sodavand", "Kildevand", "Cocio", "Fadøl", "Rødvin & hvidvin"],
            },
            {
                id: "varme-drikke",
                title: "Varme drikke",
                items: ["Kaffe & te", "Varm kakao m. flødeskum", "Gløgg med alkohol", "Gløgg uden alkohol"],
            },
            {
                id: "soedt-snacks",
                title: "Sødt & snacks",
                items: [
                    "Gl. daws is m. flødeboller, guf & syltetøj",
                    "Æbleskiver m. sukker, flormelis & syltetøj",
                    "Slush ice",
                    "Popcorn",
                ],
            },
        ],
    },
];

export const BORDE = [
    { id: "cafe-staaborde", name: "Café-ståborde" },
];

export const STROEM_TILVALG = ["Forlængerledning", "Kabeltromle", "Adapterkabel (CEE 16A)", "Gasvogn"];

export const EVENT_TYPES = [
    "Bryllup",
    "Fødselsdag",
    "Konfirmation",
    "Studenterfest",
    "Jubilæum",
    "Dåb",
    "Rejsegilde",
    "Reception",
    "Svendegilde",
    "Surprise",
    "Åbent hus",
    "Firmafest / event",
    "Andet",
];

export const slug = (s) =>
    s
        .toLowerCase()
        .replace(/æ/g, "ae")
        .replace(/ø/g, "o")
        .replace(/å/g, "a")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");

export function buildSummary(servingType, menuId, natmadAddition, guests, tilvalgSet, bordeQty, stroemSet, deselected = {}) {
    const menu = MENUS.find((m) => m.id === menuId) || null;
    const isNatmad = servingType === "natmad";
    const lines = [];
    const additions = [];
    const menuFravalg = menu ? menu.contents.filter((c) => deselected[c]) : [];
    if (menu) {
        lines.push(isNatmad ? `${menu.name} (natmad)` : `${menu.name} — ${menu.tagline}`);
        if (menuFravalg.length) lines.push(`Uden: ${menuFravalg.join(", ")}`);
    }
    if (isNatmad && natmadAddition) {
        lines.push(natmadAddition);
        additions.push({ name: natmadAddition, qty: 1 });
    }
    if (!isNatmad) {
        Object.keys(tilvalgSet).forEach((k) => {
            if (tilvalgSet[k]) {
                lines.push(k);
                additions.push({ name: k, qty: 1 });
            }
        });
        BORDE.forEach((b) => {
            const qty = bordeQty[b.id] || 0;
            if (qty > 0) {
                lines.push(`${b.name} × ${qty}`);
                additions.push({ name: b.name, qty });
            }
        });
        Object.keys(stroemSet).forEach((k) => {
            if (stroemSet[k]) {
                lines.push(k);
                additions.push({ name: k, qty: 1 });
            }
        });
    }
    return { menu, lines, additions, menuFravalg, natmadAddition, servingType };
}
